import { ContentfulProductType as ProductType } from '@reward-platform/contentful'

export const mapPathToPromotionProduct = (pathname: string): ProductType | undefined => {
  if (pathname.includes(`/hotels`) || pathname.includes(`tab=hotels`)) {
    return 'HOTEL'
  }
  if (pathname.includes(`/cars`) || pathname.includes(`tab=carhire`)) {
    return 'CAR_HIRE'
  }
  if (pathname.includes(`/experiences`) || pathname.includes(`tab=experiences`)) {
    return 'EXPERIENCE'
  }
  if (pathname.includes(`/flights`) || pathname.includes(`tab=flights`)) {
    return 'FLIGHT'
  }
  return undefined
}
